import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';


import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-ordermethod-dropdown',
  templateUrl: './OrderMethodDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => OrderMethodDropdownComponent)}]
})
export class OrderMethodDropdownComponent extends BaseDropdownComponent {
   
    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
    }
    @Input() setValueToDefault: boolean;
    @Input() disabled: boolean;


    ngOnInit(): void {
    }

    public load(){

        this.domainDataService.getOrderMethods().subscribe(x=> this.onGetOrderMethodsDone(x));
    }
    
    onGetOrderMethodsDone(items: ent.OrderMethod[]){
        this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
        if (this.selectedID){
            this.value = this.selectedID;
        }
        else{
            if (this.setValueToDefault){
                var defaultItems = items.filter(x=>x.ID == Constants._DEFAULT_ORDER_METHOD_ID);
                if (defaultItems.length > 0){
                    this.value = defaultItems[0].ID;
                }
            }
            
        }
    }

}